<template>
  <div class="add-express-code">
    <div class="express-code-import-card">
      <div class="source">
        <el-upload
          class="upload-demo"
          name="order"
          drag
          :headers="headers"
          :on-success="handleSuccess"
          :on-error="handleError"
          action="/index/order/import"
          multiple>
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
          <div class="el-upload__tip" slot="tip">只能上传xls/xlsx文件，且不超过8MB</div>
        </el-upload>
      </div>
    </div>
  </div>
</template>

<script>
import { Message } from 'element-ui'
export default {
  data: () => ({
    headers: {
      'X-Requested-With': 'XMLHttpRequest'
    }
  }),
  methods: {
    handleSuccess: (response, file, fileList) => {
      console.log(response)
      if (response.code === 1) {
        Message({
          type: 'success',
          message: response.msg
        })
      } else {
        Message({
          type: 'warning',
          message: response.msg
        })
      }
    },
    handleError: (err, file, fileList) => {
      console.log(err)
      Message({
        type: 'warning',
        message: '服务器异常'
      })
    }
  }
}
</script>

<style lang="less">
.source {
    padding: 24px;
}
.el-select-dropdown__item{
  height: 22px;
  line-height: 22px;
}
.el-select-dropdown__wrap{
  max-height: 350px;
}
.express-code-import-card {
  max-width: 420px;
  min-height: 300px;
  padding: 32px 0;
  background: #fff;
  margin: 30px auto;
  box-shadow: 0px 2px 12px 1px rgba(34, 82, 177, 0.07);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-self: center;

  .el-input-group{
    width: 300px;
  }

  .el-textarea__inner {
    border-bottom: 2px solid #ccccd8 !important;
  }

  .card-content {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  .card-btn {
    margin: 17px auto;
    width: 100%;
    display: flex;
    justify-content: center;
  }

  .card-top {
    width: 670px;
    margin: 0 auto;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }

  .card-bottom {
    width: 670px;
    border: 2px solid #ccccd8;
    border-radius: 6px;
    margin: 0 auto;

    .head {
      width: 100%;
      height: 60px;
      border-bottom: 2px solid #ccccd8;
      font-size: 18px;
      font-weight: 400;
      color: #6e6f95;
      display: flex;
      align-items: center;
      padding-left: 13px;
    }

    .el-textarea {
      height: 166px;
      padding-bottom: 10px;
      border: none;
      textarea {
        border: none;
      }
    }

    .footer {
      width: 100%;
      // height: 164px;
      min-height: 164px;
      padding: 20px;
      border-top: 2px solid #ccccd8;

      .el-upload--picture-card {
        width: 80px;
        height: 80px;
        display: flex;
        justify-content: center;
        align-items: center;
        background: #dddfe3;
        border: none;
      }

      .el-upload-list__item {
        width: 80px;
        height: 80px;
      }
    }
  }

  .submit {
    width: 250px;
    height: 50px;
    background: #00a4a4;
    border-color: #00a4a4;
  }

  .el-input-group__prepend {
    width: 123px;
    height: 40px;
    padding: 0 20px;
    vertical-align: middle;
    background: #F0F1F4;
    font-size: 14px;
    font-weight: 400;
    color: #6E6F95;
  }

  .el-input__inner {
    width: 177px;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }

  .input-select {
    height: 40px;
    display: flex;
    line-height: normal;
    display: inline-table;
    border-collapse: separate;
    border-spacing: 0;
    font-size: 14px;
    .diy-suffix {
      position: relative;
      .diy-suffix-icon {
        position: absolute;
        right: 7px;
        top: 12px;
        cursor: pointer;
      }
      .el-input__suffix {
        display: none;
      }
      .el-input__inner {
        height: 40px;
      }
      .el-date-editor {
        width: 198px;
        margin-bottom: 5px;
        .el-input__inner {
          padding: 0 15px;
        }
        .el-input__prefix {
          display: none;
        }
      }
    }
  }
}
</style>
